import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const ThinArrowDownIconSvg = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 9L12 14.5L17.5 9" stroke="currentColor"/>
    </svg>
)
const ThinArrowDownIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ThinArrowDownIconSvg}
    </SvgIcon>
);
export default ThinArrowDownIcon
